// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i5n8B","tabsBox":"styles_tabsBox__3kAwG","createButton":"styles_createButton__2vmU7"};